import type { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

export enum REPORT_LOCATION {
    slideList = 0,
    slideListRight,
    slideRight,
    mobileToolbar,
    mobileSlideList,
    mobileSlide,
    mobilePreview,
}

export interface IAiReplaceSlideMobileService {
    showPanel: () => void;
    // 在移动端预览页展示
    showPanelInPreview: () => void;
    canUseAIReplace(slide: ISlideModel): boolean;
}

export interface ShowModalProps {
    onClose?: () => void;
    position?: { x?: number; y?: number };
    location?: REPORT_LOCATION;
}

export interface IAiReplaceSlidePCService {
    showModal: (props: ShowModalProps) => void;
    setDefaultPosition: (x?: number, y?: number) => void;
}
